import React from "react";


export default function QuickActions({ actions, onActionClick }) {
  return (
    <div className="quick-actions">
      {actions.map((action, index) => (
        <button
          key={index}
          className="chip"
          onClick={() => onActionClick(action.value)}
        >
          {action.label}
        </button>
      ))}
    </div>
  );
}